<template>
    <div id="app" class="wrapper">

        <!-- MAIN -->
        <main class="" id="content">
                <LeftPanel @logout="logout"></LeftPanel>
                <div class="main-wrapper">
                <Header
                    :notifications="notifications"
                    :notification_count="notification_count"
                    :so-notifications="soNotifications"
                    :po-notifications="poNotifications"
                    @logout="logout"
                    @onDismissAllNotification="dismissAllNotification"
                    @onDismissNotification="dismissNotification"></Header>
                <router-view :key="$route.fullPath" />
                </div>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import LeftPanel from "../../components/LeftPanel";

import { mapState, mapActions, mapGetters  } from 'vuex';
import axios from "axios";

export default {
    name: "Admin",
    components: {
        Header,
        Footer,
        LeftPanel
    },
    beforeMount() {
        this.getUserNotifications();
    },
    updated() {
        // this.getUserNotifications();
    },
    data() {
      return {
          authUser: null,
          notifications: [],
          notification_count: 0,
          soNotifications:[],
          poNotifications:[],
      }
    },
    methods: {
        ...mapActions([
            'setAuth',
            'clearAuth',
            'setLoginLoading',
            'setLoading',
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setSettings',
            'setCarriers',
            'setExportFile'
        ]),
        logout() {
            let self = this;
            localStorage.removeItem('auth');
            self.clearAuth();
            //self.$router.push({ name: 'login' });
            /*this.setLoginLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(window.route('logout'), this.form, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        localStorage.removeItem('auth');
                        self.clearAuth();
                        self.$router.push({ name: 'login' });
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);
                })
                .finally(() => {
                    self.setLoginLoading(false);
                });*/
        },
        getUserNotifications() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('api.getUserNotifications'), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.success){
                        this.notifications = data.notification_data;
                        this.notification_count = data.total;
                        this.soNotifications = data.so;
                        this.poNotifications = data.po;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        dismissAllNotification() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('api.dismiss_all_notifications'),  {},{

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.success){
                        self.getUserNotifications();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        dismissNotification(event) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('api.mark_cmplt_notifications'), {id: event.item.id, type: event.type},{

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.success){
                        self.getUserNotifications();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getSettings() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('global-setting.index'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        self.setSettings(data.data);
                        self.setCarriers(data.carriers);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage'
        ])
    },
    created() {
        /*this.$echo.logToConsole = true;
        this.$echo.private('events')
            .listen('.RealTimeMessage', (e) => {
                console.log('test successful ', e);
                this.$bvToast.toast(`${e.message}`, {
                    title: 'Notification',
                    autoHideDelay: 5000,
                    appendToast: true,
                    variant: 'success',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                })
            });*/
    },
    mounted() {
        let auth = localStorage.getItem("auth");
        if(this.getAuthUser != null){
            this.authUser = this.getAuthUser;
            //console.log(this.authUser);
        } else if(typeof auth != 'undefined' && auth != 'undefined') {
            //console.log(auth);
           this.authUser = auth.user;
        }

        if(this.authUser) {
            this.getSettings();

            this.$echo.private('quotation')
                .listen('.QuotationCreated', (e) => {
                    console.log(e)
                    console.log("Loaded")
                });



            this.$echo.private(`App.Models.Admin.${this.authUser.id}`)
                .notification((notification) => {
                    //console.log('notification test',notification);
                    if(notification.type == 'quotation') {
                        this.$bvToast.toast(notification.notification.body, {
                            title: notification.notification.title ? notification.notification.title : 'Notification',
                            autoHideDelay: 5000,
                            appendToast: true,
                            variant: 'success',
                            solid: true,
                            toaster: 'b-toaster-bottom-right',
                            to: { name: 'viewQuote', params: { id: notification.notification.quote_id } }
                        });
                    } else if(notification.type == 'order') {
                        this.$bvToast.toast(notification.notification.body, {
                            title: notification.notification.title ? notification.notification.title : 'Notification',
                            autoHideDelay: 5000,
                            appendToast: true,
                            variant: 'success',
                            solid: true,
                            toaster: 'b-toaster-bottom-right',
                            to: { name: 'orderShow', params: { id: notification.notification.order_id } }
                        });
                    } else if(notification.type == 'purchase') {
                        this.$bvToast.toast(notification.notification.body, {
                            title: notification.notification.title ? notification.notification.title : 'Notification',
                            autoHideDelay: 5000,
                            appendToast: true,
                            variant: 'success',
                            solid: true,
                            toaster: 'b-toaster-bottom-right',
                            to: { name: 'purchaseOrderShow', params: { id: notification.notification.order_id } }
                        });
                    } else if(notification.type == 'task') {
                        console.log(notification.notification);
                        let to = null;
                        if(notification.notification.order) {
                            to = { name: 'orderShow', params: { id: notification.notification.order.id } };
                        } else if(notification.notification.purchaseOrder) {
                            to = { name: 'purchaseOrderShow', params: { id: notification.notification.purchaseOrder.id } };
                        }
                        this.$bvToast.toast(notification.notification.task.title, {
                            title: notification.notification.title ? notification.notification.task.title : 'Task Notification',
                            autoHideDelay: 5000,
                            appendToast: true,
                            variant: 'success',
                            solid: true,
                            toaster: 'b-toaster-bottom-right',
                            to: to
                        });
                    } else if(notification.type == 'reminder') {
                        console.log(notification.notification);
                        let to = null;
                        if(notification.notification.order) {
                            to = { name: 'orderShow', params: { id: notification.notification.order.id } };
                        } else if(notification.notification.purchaseOrder) {
                            to = { name: 'purchaseOrderShow', params: { id: notification.notification.purchaseOrder.id } };
                        }
                        this.$bvToast.toast(notification.notification.reminder.title, {
                            title: notification.notification.title ? notification.notification.reminder.title : 'Reminder Notification',
                            autoHideDelay: 5000,
                            appendToast: true,
                            variant: 'success',
                            solid: true,
                            toaster: 'b-toaster-bottom-right',
                            to: to
                        });
                    } else {
                        this.$bvToast.toast(notification.message, {
                            title: 'Notification',
                            autoHideDelay: 5000,
                            appendToast: true,
                            variant: 'success',
                            solid: true,
                            toaster: 'b-toaster-bottom-right'
                        })
                    }

                })
                .listen('OrderExcelExportReady',(e)=>{
                    //code for displaying the serve data
                    console.log(e); // the data from the server
                    this.setExportFile(e.exportFile);
                    let to = { name: 'orderShow', params: { } };
                    this.$bvToast.toast('Report file is ready to download', {
                        title: "Orders Report",
                        autoHideDelay: 5000,
                        appendToast: true,
                        variant: 'success',
                        solid: true,
                        toaster: 'b-toaster-bottom-right',
                        to: to
                    });
                })
                .listen('OrderExcelExportFailed',(e)=>{
                    //code for displaying the serve data
                    //console.log(e); // the data from the server
                    this.setExportFile(null);
                    this.$bvToast.toast('Something went wrong to export file!', {
                        title: "Orders Report",
                        autoHideDelay: 5000,
                        appendToast: true,
                        variant: 'error',
                        solid: true,
                        toaster: 'b-toaster-bottom-right',
                    });
                });
        }

    }
}
</script>

<style scoped>

</style>
